export default "__VITE_ASSET__uxRzNmoL__"